import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PriceDTO } from "@shared/models/price-dto";
import { environment } from "@env";
import {
  ServiceDTO,
  ServiceFindByFiltersDTO
} from "@shared/models/service-dto";
import { PageManager } from "@shared/models/page-manager";
import { Pagination } from "@shared/models/pagination";

@Injectable({
  providedIn: "root"
})
export class ServiceBoschService {
  private serviceUrl = "services/";

  constructor(private http: HttpClient) {}

  findById(id: number): Observable<ServiceDTO> {
    return this.http.get<ServiceDTO>(
      environment.apiUrl + `${this.serviceUrl}${id}`
    );
  }

  findByIdDefaultServicePrice(
    id: number,
    codeCurrency: string
  ): Observable<PriceDTO> {
    return this.http.get<PriceDTO>(
      environment.apiUrl +
        `${this.serviceUrl}${id}/default-price?currencyCode=${codeCurrency}`
    );
  }

  findByRegion(
    id: number,
    carWorkshopId: number,
    serviceRequestId: number
  ): Observable<any> {
    let params = new HttpParams();
    params = params.set("serviceRequestId", serviceRequestId.toString());
    return this.http.get(
      `${environment.apiUrl}${this.serviceUrl}${id}/car-workshops/${carWorkshopId}/prices`,
      { params }
    );
  }

  findByFilters(
    searchFormDTO: ServiceFindByFiltersDTO,
    pageManager: PageManager,
    sort = ""
  ): Observable<Pagination<ServiceDTO[]>> {
    let query = "";
    if (searchFormDTO.name) {
      query += `&name=${searchFormDTO.name}`;
    }
    if (searchFormDTO.nameFilter) {
      query += `&nameFilter=${searchFormDTO.nameFilter}`;
    }
    if (searchFormDTO.clientId) {
      query += `&clientId=${searchFormDTO.clientId}`;
    }

    if (searchFormDTO.fee) {
      if (searchFormDTO.vehicleId) {
        query += `&vehicleId=${searchFormDTO.vehicleId}`;
      }

      query += `&fee=${searchFormDTO.fee}`;
    }

    return this.http.get<Pagination<ServiceDTO[]>>(
      environment.apiUrl +
        `${this.serviceUrl}filters?page=${pageManager.pageIndex}&size=${pageManager.pageSize}${query}${sort}`
    );
  }
}
